/*
 * @Author: tanyaohua
 * @Date: 2019-12-31 13:26:12
 * @Description: 稿件其他信息 */
'use strict';
angular.module('AppOtherInfoModule', []).directive('appOtherInfo', [
    '$timeout',
    '$filter',
    'editingCenterService',
    'ueditorService',
    'messagePublishService',
    function($timeout, $filter, editingCenterService, ueditorService, messagePublishService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/app/appOtherInfo/appOtherInfo.html',
            replace: true,
            transclude: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.data = {
                        commonAuthor: [
                            {
                                text: '记者',
                            },
                            {
                                text: '编辑',
                            },
                            {
                                text: '通讯员',
                            },
                        ], // 常用作者类型
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    messagePublishService.subscribe(
                        'hasGetEditInfo',
                        function(event, data) {
                            initKeyWords();
                        },
                        $scope
                    );
                }

                /**
                 * [initKeyWords description]初始化关键词
                 * @return {[type]} [description]
                 */
                function initKeyWords() {
                    if ($scope.list.KEYWORDS && $scope.list.KEYWORDS.length) {
                        var KEYWORDS = $scope.list.KEYWORDS.split(';');
                        // angular.forEach($scope.list.KEYWORDS, function(data, index, array) {
                        //     $scope.list.KEYWORDS[index].name = $scope.list.KEYWORDS[index].NAME; // 根据组件要求改为小写
                        // });
                        $scope.parentData.KEYWORDS = [];
                        angular.forEach(KEYWORDS, function(value, key) {
                            $scope.parentData.KEYWORDS.push({
                                name: value,
                            });
                        });
                    } else {
                        $scope.parentData.KEYWORDS = [];
                    }
                }

                /**
                 * [invalidTag description] 检验关键词的总个数和总记录长度
                 * @param   {[type]}  tag  [tag description]
                 * @return  {[type]}       [return description]
                 */
                $scope.invalidTag = function(tag) {
                    var reg = /^[^<>\/;]*$/;
                    if (tag.name.length > 20) {
                        $scope.isShowKeywordTips = true;
                        $scope.keywordsTips = '单个关键词长度不能超过20！';
                    }
                    if (!reg.test(tag.name)) {
                        $scope.isShowKeywordTips = true;
                        $scope.keywordsTips = '不能包含特殊字符！';
                    }
                };

                /**
                 * [checkTag description]
                 * @param   {[type]}  tag  [tag description]
                 * @return  {[type]}       [return description]
                 */
                $scope.checkTag = function(tag) {
                    var len = $scope.parentData.KEYWORDS.length;
                    if (len == 10) {
                        $scope.isShowKeywordTips = true;
                        $scope.keywordsTips = '关键词个数不能超过10个！';
                        return false;
                    } else {
                        $scope.keywordsTips = '';
                        $scope.isShowKeywordTips = false;
                    }
                    if (tag.name.indexOf(' ') > -1) {
                        var spaceArr = tag.name.split(' ');
                        $timeout(function() {
                            $scope.parentData.KEYWORDS.pop();
                            var containArr = [];
                            for (var j = 0; j < $scope.parentData.KEYWORDS.length; j++) {
                                containArr.push($scope.parentData.KEYWORDS[j].name);
                            }
                            for (var i = 0; i < spaceArr.length; i++) {
                                if (containArr.indexOf(spaceArr[i]) < 0 && spaceArr[i] != '') {
                                    $scope.parentData.KEYWORDS.push({ name: spaceArr[i] });
                                    containArr.push(spaceArr[i]);
                                }
                            }
                        });
                    }
                };

                /**
                 * [leave description]
                 * @return  {[type]}  [return description]
                 */
                $scope.leave = function() {
                    // $scope.isShowKeywordTips = false;
                };

                /**
                 * [enter description]
                 * @return  {[type]}  [return description]
                 */
                $scope.enter = function() {
                    var reg = /^[^<>\/]*$/;
                    if (angular.isDefined($scope.KEYWORDTEXT) && (!reg.test($scope.KEYWORDTEXT) || $scope.KEYWORDTEXT.length > 20)) {
                        $scope.isShowKeywordTips = true;
                    }
                };

                /**
                 * [addkeywords description] 添加关键词
                 * @param   {[type]}  e  [e description]
                 * @return  {[type]}     [return description]
                 */
                $scope.addkeywords = function(e) {
                    if (e.keyCode == 32 && $scope.list.KEYWORDS.indexOf($scope.keywordTxt) < 0) {
                        $scope.parentData.KEYWORDS.push($scope.keywordTxt);
                        $scope.keywordTxt = '';
                    }
                };

                /**
                 * [delete description] 删除关键词
                 * @param   {[type]}  record  [record description]
                 * @return  {[type]}          [return description]
                 */
                $scope.delete = function(record) {
                    $scope.list.KEYWORDS.splice(record, 1);
                };
                
                /**
                 * [clearAllKeywords description]清除关键词
                 * @return {[type]} [description]
                 */
                $scope.clearAllKeywords = function() {
                    $scope.list.KEYWORDS = [];
                };

                /**
                 * [getKeywordsOrAbstract description]提取关键词或摘要
                 * @param  {[str]} type [description]关键词类型或摘要
                 * @return {[type]}      [description]
                 */
                $scope.getKeywordsOrAbstract = function(type) {
                    editingCenterService.getKeywordsOrAbstract(type, ueditorService.bindContentForKeyword()).then(
                        function(data) {
                            if (type === 'keywords') {
                                if (data !== '""') {
                                    var arr = [];
                                    var keywordsArray = data.substring(1, data.length - 1).split(';');
                                    angular.forEach(keywordsArray, function(value, key) {
                                        arr.push({
                                            name: value,
                                        });
                                    });
                                    $scope.parentData.KEYWORDS = angular.isArray($scope.parentData.KEYWORDS) ? $scope.parentData.KEYWORDS : [];
                                    $scope.parentData.KEYWORDS = $scope.parentData.KEYWORDS.concat(arr);
                                    $scope.parentData.KEYWORDS = $filter('unique')($scope.parentData.KEYWORDS, 'name');
                                    if ($scope.parentData.KEYWORDS.length > 10) {
                                        $scope.parentData.KEYWORDS = $scope.parentData.KEYWORDS.splice(0, 10);
                                    }
                                } else {
                                    return;
                                }
                            }
                            if (type === 'abstract') {
                                $scope.list.ABSTRACT = data.substring(1, data.length - 1);
                            }
                        },
                        function(data) {}
                    );
                };

                /**
                 * [clearAllKeywords description]清楚关键词
                 * @return {[type]} [description]
                 */
                $scope.clearAllKeywords = function() {
                    $scope.parentData.KEYWORDS = [];
                };

                /**
                 * [clickCommonAuthor description]添加作者快速功能
                 * @param   {[object]}    item     [item description] 当前选择项
                 * @return  {[undefined]}          [return description]
                 */
                $scope.clickCommonAuthor = function(item) {
                    $scope.list.SIGNATUREAUTHOR += item.text;
                };
            },
        };
    },
]);
